// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LoginPage.module.css */
.LoginPage_loginImage__fSNyf {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 1rem; /* Matches the rounded-2xl in Tailwind */
 
}`, "",{"version":3,"sources":["webpack://./src/component/login/LoginPage.module.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB,EAAE,wCAAwC;;AAE/D","sourcesContent":["/* LoginPage.module.css */\n.loginImage {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 1rem; /* Matches the rounded-2xl in Tailwind */\n \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginImage": `LoginPage_loginImage__fSNyf`
};
export default ___CSS_LOADER_EXPORT___;
